define('modules/editor/behaviours/alignable',['require','exports','module','backbone','backbone','../models/editorstate'],function(require, exports, module) {
  "use strict";

  var Collection = require("backbone").Collection,
      Model = require("backbone").Model,
      EditorState = require("../models/editorstate"),
      GroupState = EditorState.groupState,
      MoveState = EditorState.moveState;

  module.exports = {
    _checkAlignment: function(model, position) {
      if (!position || this._containsMovingViews()) {
        this._cleanAlignment();
        return;
      }
      if (!GroupState.contains(this) && !this._hasCalculatedPoints) {
        GroupState.elements.each(function(item){
          item.get("view").addStaticPositions(this._calculateHorizontalPoints(), this._calculateVerticalPoints());
        }, this);
        this._hasCalculatedPoints = true;
      }
    },
    isMoving: function() {
      var movingView = MoveState.getMovingView();
      return movingView && this.$el === movingView.$el;
    },
    _containsMovingViews: function() {
      return this._childViews && _.contains(this._childViews, GroupState.getFirstView());
    },
    _cleanAlignment: function(){
      this.staticPoints.reset();
      this._hasCalculatedPoints = false;
    },
    _calculateHorizontalPoints: function() {
      return this._calculatePoints("horizontal");
    },
    _calculateVerticalPoints: function() {
      return this._calculatePoints("vertical");
    },
    _calculatePoints: function(orientation) {
      var isH = orientation === "horizontal",
          delta = this.parent.getDelta(),
          origin = parseInt(this.$el.css(isH? "left" : "top")),
          length = parseInt(this.$el.css(isH? "width" : "height"));
      origin += !isH? delta.top : delta.left;
      return [origin, Math.floor(origin + length/2), origin + length];
    },
    _pointsToModels: function(points, orientation) {
      var isH = orientation === "horizontal";
      return _.map(points, function(point){
        var attr = {};
        attr[isH? "left": "top"] = point;
        return new Model(attr);
      });
    },
    addStaticPositions: function(xPoints, yPoints) {
      this.staticPoints.add(this._pointsToModels(xPoints, "horizontal"));
      this.staticPoints.add(this._pointsToModels(yPoints, "vertical"));
    },
    getAlignment: function() {
      var xs = this._calculateHorizontalPoints(),
          ys = this._calculateVerticalPoints(),
          commonx = this._findPoints(xs, "left"),
          commony = this._findPoints(ys, "top");
      this._handleSnap(commony, commonx);
      return _.union(commonx, commony);
    },
    _findPoints: function(points, position) {
      var query = {};
      return _.reduce(points, function(acc, point){
        query[position] = point;
        var model = this.staticPoints.findWhere(query);
        if (model) acc.push(model);
        return acc;
      }, [], this);
    },
    _handleSnap: function(horizontally, vertically) {
      var snap = EditorState.get("snap") || {x: false, y: false};
      snap = {
        x: snap.x || !!vertically.length,
        y: snap.y || !!horizontally.length
      };
      EditorState.set("snap", snap);
    },
    mixed: function(klass, proto) {
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init) {
        this.listenTo(MoveState, "change:movingLastPos", this._checkAlignment);
        this.staticPoints = new Collection();
        return init.apply(this, _.rest(arguments));
      });
    }
  };
});

